import styles from './DoctorBuddy.module.css';
import doctor from '../../assets/kito-doctor.svg';
import PropTypes from 'prop-types';

export default function KitoDoctorBuddy({ title, searchQuery, setSearchQuery, name, placeholder }) {
    return <div className={styles.container}>
        <div className={styles.intro}>
            <h2 className={styles.title}>{title}</h2>
            <img className={styles.doctor} src={doctor} alt='doctor-buddy' />
        </div>
        <input
            name={`search-${name}`}
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder={placeholder}
            className={styles.input}
        />
    </div>
}

KitoDoctorBuddy.propTypes = {
    title: PropTypes.string.isRequired,
    searchQuery: PropTypes.string.isRequired,
    setSearchQuery: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired
};